import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { RunList } from '@/components/knowledge/RunList';
import { RunDetail } from '@/components/knowledge/RunDetail';
import { useRunsStore } from '@/stores/runs';

export function ResearchRunsPage() {
  const { runId } = useParams<{ runId?: string }>();
  const { fetchRunDetail, selectRun } = useRunsStore();

  useEffect(() => {
    if (runId) {
      fetchRunDetail(runId);
    } else {
      selectRun(null);
    }
  }, [runId, fetchRunDetail, selectRun]);

  return (
    <div className="flex flex-col h-full bg-slate-50">
      <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-white">
        <div>
          <h1 className="text-xl font-semibold text-navy-900">Research Runs</h1>
          <p className="text-sm text-slate-500 mt-0.5">
            knowledge_research executions — customer enrichment, market research,
            brand design
          </p>
        </div>
      </div>

      <div className="flex flex-1 min-h-0">
        <div className="w-80 flex-shrink-0">
          <RunList />
        </div>
        <div className="flex-1 min-w-0 bg-white">
          <RunDetail />
        </div>
      </div>
    </div>
  );
}
